import React from 'react';
import styled from 'styled-components';
import { Button } from 'primereact/button';
import { formatDate } from 'util/utils';

type Props = {
  id?: string;
  companyName?: string;
  createdAt?: string;
  onRemoveRequest: (id: string, companyName: string) => void;
};

const RequestItem: React.FC<Props> = ({ id, companyName, createdAt, onRemoveRequest }) => {
  return (
    <Container>
      <CompanyName>{companyName}</CompanyName>

      <RequestDateAndActionsContainer>
        <RequestDate>{formatDate(createdAt)}</RequestDate>
        <Delimiter />
        <DeclineRequestButton
          label="Remove request"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onRemoveRequest(id!, companyName!);
          }}
        />
      </RequestDateAndActionsContainer>
    </Container>
  );
};

export default RequestItem;

const Container = styled.div`
  width: 100%;
  height: 48px;
  background-color: #fff;
  border-radius: 4px;
  padding: 16px 0 16px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
`;

const CompanyName = styled.span`
  ${(props) => props.theme.typography.bodyInput}
  color: ${(p) => p.theme.colors.primaryBlack};
`;

const RequestDateAndActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;

const RequestDate = styled.span`
  ${(props) => props.theme.typography.bodyInput}
  color: #15151580;
`;

const Delimiter = styled.div`
  width: 1px;
  height: 16px;
  background-color: ${(p) => p.theme.colors.elementsInputBorder};
  margin-left: 12px;
  margin-right: 11px;
`;

const DeclineRequestButton = styled(Button)`
  height: 22px;
  width: 135px;
  border-radius: 2px;

  background-color: ${(p) => p.theme.colors.primaryOrange};
  border-color: ${(p) => p.theme.colors.primaryOrange};
  color: ${(p) => p.theme.colors.primaryWhite};

  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
`;
